<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div class="card">
        <div v-if="isRedirected">
          <div class="row">
            <div class="col-12 text-right">
              <button class="btn btn-link" @click="clearQueryParams">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div v-if="pausedBrokersList.length > 0">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Paused Brokers</h3>
                </div>
              </div>
            </div>
            <div class="card-header border-0">
              <div class="row align-items-center justify-content-end">
                <div class="col-12 col-md-4 d-flex justify-content-center">
                  <base-input name="broker-select" class="w-100 ml-2">
                    <el-select v-model="brokerSearchKeyword" filterable allow-create clearable
                      placeholder="Select or enter Broker" default-first-option>
                      <el-option v-for="broker in pausedBrokersList" :key="broker.broker" :label="broker.broker"
                        :value="broker.broker" />
                    </el-select>
                  </base-input>
                </div>
                <div class="col-12 col-md-2 d-flex justify-content-center justify-content-lg-start">
                  <base-button class="ml-2 mt-0 mb-4 mr-2" size="md" type="primary" @click="applyBrokerSearch">
                    Search
                  </base-button>
                </div>
              </div>
            </div>
            <el-table :data="filteredBrokers" header-row-class-name="thead-light">
              <el-table-column label="Sl. No" prop="slNo" min-width="120px"></el-table-column>
              <el-table-column label="Broker" prop="broker" min-width="160px"></el-table-column>
              <el-table-column label="Status" min-width="150px">
                <template v-slot:default="props">
                  <span class="badge badge-danger">{{ props.row.status }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="card-footer d-flex justify-content-between flex-wrap align-items-center">
              <p class="small mb-0">
                Showing {{ brokerFrom + 1 }} to {{ Math.min(brokerTo, brokerTotal) }} of {{ brokerTotal }} brokers
              </p>
              <el-pagination v-if="!brokerSearchKeyword && brokerTotal > brokerPageSize" background
                layout="prev, pager, next" :total="brokerTotal" :page-size="brokerPageSize"
                @current-change="handleBrokerPageChange" />
            </div>
          </div>
          <div v-if="pausedUsersList.length > 0">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Paused Users</h3>
                </div>
              </div>
            </div>
            <div class="card-header border-0">
              <div class="row align-items-center justify-content-end">
                <div class="col-12 col-md-4 d-flex justify-content-center">
                  <base-input name="user-select" class="w-100 ml-2">
                    <el-select v-model="userSearchKeyword" filterable clearable placeholder="Select Paused User">
                      <el-option v-for="user in pausedUsersList" :key="user.userId"
                        :label="user.userName + ' (' + user.userId + ')'" :value="user.userId" />
                    </el-select>
                  </base-input>
                </div>
                <div class="col-12 col-md-2 d-flex justify-content-center justify-content-lg-start">
                  <base-button class="ml-2 mt-0 mb-4 mr-2" size="md" type="primary"
                    @click="applyUserSearch">Search</base-button>
                </div>
              </div>
            </div>
            <el-table :data="filteredUsers" header-row-class-name="thead-light">
              <el-table-column label="Sl.No" prop="slNo" min-width="120px"></el-table-column>
              <el-table-column label="User ID" prop="userId" min-width="150px"></el-table-column>
              <el-table-column label="User Name" prop="userName" min-width="160px"></el-table-column>
              <el-table-column label="Status" min-width="150px">
                <template v-slot:default="props">
                  <span class="badge badge-warning">{{ props.row.status }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="card-footer d-flex justify-content-between flex-wrap align-items-center">
              <p class="small mb-0">
                Showing {{ userFrom + 1 }} to {{ Math.min(userTo, userTotal) }} of {{ userTotal }} users
              </p>
              <el-pagination v-if="!userSearchKeyword && userTotal > userPageSize" background layout="prev, pager, next"
                :total="userTotal" :page-size="userPageSize" @current-change="handleUserPageChange" />
            </div>
          </div>
          <div v-if="isPauseAll" class="card-body text-center">
            <h4 class="text-warning">All users and brokers are paused.</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ElTable, ElTableColumn, ElPagination, ElOption, ElSelect } from "element-plus";
export default {
  components: {
    [ElTable.name]: ElTable,
    [ElTableColumn.name]: ElTableColumn,
    [ElPagination.name]: ElPagination,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
  },
  data() {
    return {
      pausedBrokersList: [],
      pausedUsersList: [],
      selectedUserIds: [],
      isRedirected: false,
      isPauseAll: false,
      brokerSearchText: '',
      brokerSearchKeyword: '',
      userSearchText: '',
      userSearchKeyword: '',
      brokerPageSize: 10,
      brokerCurrentPage: 1,
      brokerTotal: 0,
      userPageSize: 10,
      userCurrentPage: 1,
      userTotal: 0,
      selectOptions: [],
      isBrokerLoading: false,
      selectBroker: [],
    };
  },
  computed: {
    filteredBrokers() {
      let result = this.pausedBrokersList;
      if (this.brokerSearchText) {
        const keyword = this.brokerSearchText.toLowerCase();
        result = result.filter(broker =>
          broker.broker.toLowerCase().includes(keyword)
        );
      }
      const start = (this.brokerCurrentPage - 1) * this.brokerPageSize;
      return result.slice(start, start + this.brokerPageSize);
    },
    filteredSuggestions() {
      if (!this.userSearchText) return [];
      return this.selectOptions
        .map(opt => ({
          key: opt.key,
          label: opt.value.split('(')[0].trim()
        }))
        .filter(opt =>
          opt.label.toLowerCase().includes(this.userSearchText.toLowerCase())
        );
    },
    filteredUsers() {
      let result = this.pausedUsersList;
      if (this.userSearchText) {
        const keyword = this.userSearchText.toLowerCase();
        result = result.filter(user =>
          user.userId.toLowerCase().includes(keyword) ||
          user.userName.toLowerCase().includes(keyword)
        );
      }
      return result.slice(
        (this.userCurrentPage - 1) * this.userPageSize,
        this.userCurrentPage * this.userPageSize
      );
    },
    brokerFrom() {
      return (this.brokerCurrentPage - 1) * this.brokerPageSize;
    },
    brokerTo() {
      return this.brokerFrom + this.filteredBrokers.length;
    },
    userFrom() {
      return (this.userCurrentPage - 1) * this.userPageSize;
    },
    userTo() {
      return this.userFrom + this.filteredUsers.length;
    }
  },
  methods: {
    handleBrokerPageChange(newPage) {
      this.brokerCurrentPage = newPage;
    },
    handleUserPageChange(newPage) {
      this.userCurrentPage = newPage;
    },
    handleBrokerSearch(query) {
      if (!query || query.length < 1) {
        this.loadAllBrokers();
        return;
      }
      this.setTable(1, 10, 'name', 'ASC', query, 'name');
    },
    loadAllBrokers() {
      this.setTable(1, 50, 'name', 'ASC', '', '');
    },
    setTable(pageNo, pageSize, sortBy, direction, filter, filterField) {
      this.isBrokerLoading = true;
      const data = {
        pageNo: pageNo - 1,
        pageSize,
        sortBy,
        direction,
        filter,
        filterField
      };
      this.$store.dispatch("brokerStore/getBrokerDetails", data, { root: true })
        .then(response => {
          this.selectBroker = response.server.data.brokerDetails || [];
          this.isBrokerLoading = false;
        })
        .catch(error => {
          console.error('Failed to fetch brokers:', error);
          this.isBrokerLoading = false;
        });
    },
    applyBrokerSearch() {
      const keyword = this.brokerSearchKeyword?.trim().toLowerCase();
      this.brokerSearchText = keyword;
      this.brokerCurrentPage = 1;
    },
    applyUserSearch() {
      const keyword = this.userSearchKeyword?.trim();
      this.userSearchText = keyword;
      this.userCurrentPage = 1;
    },
    selectUserSuggestion(option) {
      this.userSearchText = option.label;
      this.userSearchKeyword = option.key;
      this.showUserSuggestions = false;
    },
    hideUserSuggestions() {
      setTimeout(() => (this.showUserSuggestions = false), 150);
    },
    clearQueryParams() {
      this.$router.push({ path: '/statusDashboard' });
      this.isRedirected = false;
      this.isPauseAll = false;
      this.pausedBrokersList = [];
      this.pausedUsersList = [];
    },
    parsePauseResponse(response) {
      this.isPauseAll = false;
      this.pausedBrokersList = [];
      this.pausedUsersList = [];
      this.brokerTotal = 0;
      this.userTotal = 0;
      const parts = response
        .split("_")
        .map(item => item.trim())
        .filter(item => item);
      if (parts.some(part => part.toUpperCase() === "PAUSEALL")) {
        this.isPauseAll = true;
        return;
      }
      const brokers = [];
      const userIds = [];
      const userKeys = this.selectOptions.map(opt => opt.key);
      parts.forEach(part => {
        if (userKeys.includes(part)) {
          userIds.push(part);
        } else {
          brokers.push(part);
        }
      });
      this.pausedBrokersList = brokers.map((broker, index) => ({
        slNo: index + 1,
        broker,
        status: "Paused"
      }));
      this.brokerTotal = this.pausedBrokersList.length;
      this.pausedUsersList = userIds.map((userId, index) => {
        const user = this.selectOptions.find(opt => opt.key === userId);
        let userName = user ? user.value : "Unknown";
        if (userName.includes("(")) {
          userName = userName.split("(")[0].trim();
        }
        return {
          slNo: index + 1,
          userId,
          userName,
          status: "Paused"
        };
      });
      this.userTotal = this.pausedUsersList.length;
    },
    getActiveUsers() {
      let data = {
        type: 'active-users'
      };
      if (sessionStorage.getItem(data.type + "-reference-data")) {
        this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
      } else {
        this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
          .then(response => {
            this.selectOptions = response.server.data;
            sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.selectOptions));
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getActiveUsers();
    const pauseResponse = sessionStorage.getItem("pause-status-response") || "";
    if (pauseResponse) {
      this.isRedirected = true;
      const interval = setInterval(() => {
        if (this.selectOptions && this.selectOptions.length > 0) {
          clearInterval(interval);
          this.parsePauseResponse(pauseResponse);
        }
      }, 100);
    }
  }
};
</script>
